import { ArrowDropDownRounded } from 'components/icons'
import { Text, XStack } from 'tamagui'

export interface Sort {
    sort: string
    sortDirection: 'asc' | 'desc'
}

interface SortableHeaderProps {
    sort: Sort | undefined
    setSort: (sort: Sort) => void
    sortString: string
    children: React.ReactNode
}

export default function SortableHeader({ sort, setSort, sortString, children }: SortableHeaderProps) {
    return (
        <XStack
            cursor="pointer"
            alignItems="center"
            gap="$1"
            onPress={() =>
                setSort({
                    sort: sortString,
                    sortDirection:
                        sort?.sort === sortString && sort?.sortDirection === 'asc' ? 'desc' : 'asc',
                })
            }
        >
            <Text fontWeight="600" fontSize="$2" color="$gray9" textTransform="uppercase" letterSpacing={0.5}>
                {children}
            </Text>
            {sort?.sort === sortString && (
                <ArrowDropDownRounded
                    style={{
                        transition: '0.2s',
                        transform: sort?.sortDirection === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                />
            )}
        </XStack>
    )
}
